import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { ProgressBar } from "react-step-progress-bar";
import "react-step-progress-bar/styles.css";
import { getUserClasses, viewSyllabus } from "../redux/actions/dataActions";


// https://xd.adobe.com/view/6b474ec3-cb43-4f80-8a1b-f5e5e38c15a4-3e14/screen/23d3ac0f-b00e-488a-bd8b-400a360e042c
// Page to show all programs the user is enrolled in
// Should login redirect to this page?
// Should we call this as My Programs instead of My Curriculum?

const styles = {
  root: {
    minWidth: "325px",
  },
  center: {
    padding: "2em auto 2em auto",
    minWidth: "325px",
  },
  containerCentral: {
    justifyContent: "center",
  },
  lightText: {
    fontWeight: "100",
  },
  card: { margin: "1.5em auto 1.5em auto" },
};

class curriculum extends Component {
  componentDidMount() {
    this.props.getUserClasses();
  }

  viewSyllabus = (programId, history) => {
    this.props.viewSyllabus(programId, history);
  };

  render() {
    const { programsUser, loading } = this.props.data;
    const { classes } = this.props;
    // this checks if the state has updated. if it hasn't, programsUser.enrolled is undefined
    let classList;
    if (!programsUser.enrolled || loading) {
      classList = (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </div>
      );
    } else {
      const enrolledPrograms = programsUser.enrolled;
      if (enrolledPrograms.length > 0) {
        classList = enrolledPrograms.map((program, i) => (
          // TODO: backend change classX to programX
          // TODO: turn this to a component (not sure if reusing ProgramCard would be useful, perhaps another one)
          <Card key ={i} variant="outlined" className="classes.card">
            <CardContent>
              <Typography variant="h4" gutterBottom>
                {program.classTitle}
              </Typography>
              <Typography variant="h5">{`${program.progress.summary}%`}</Typography>
              <ProgressBar
                percent={program.progress.summary}
                filledBackground="linear-gradient(to right, #f3a634, #f3a634)"
              />
            </CardContent>
            <CardActions>
              <Button
                size="small"
                onClick={() =>
                  this.viewSyllabus(program.classId, this.props.history)
                }
                variant="contained"
                color="secondary"
              >
                View Syllabus
              </Button>
            </CardActions>
          </Card>
        ));
      } else {
        classList = (
          <Fragment>
            <Typography variant="h4">
              You are not yet enrolled in any of the programs
            </Typography>
            <Typography size="small" variant="secondary">
              Browse some programs by clicking on ☰ and selecting All Programs 👍
            </Typography>
          </Fragment>
        );
      }
    }

    return (
      <Grid container className={classes.containerCentral}>
        <Grid item sm />
        <Grid item sm className={classes.center}>
          <Typography variant="h3">My Program</Typography>
          {classList}
        </Grid>
        <Grid item sm />
      </Grid>
    );
  }
}

curriculum.propTypes = {
  getUserClasses: PropTypes.func.isRequired,
  viewSyllabus: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps, { getUserClasses, viewSyllabus })(
  withStyles(styles)(curriculum)
);
